@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");

@import "styles/containerACS.css";
@import "styles/documentStatus.css";
@import "styles/editBoxBtn.css";
@import "styles/factureDetailLine.css";
@import "styles/formDetailClasses.css";
@import "styles/legacyStylesheet.css";
@import "styles/muiFrameworkOverride.css";
@import "styles/navBarCpn.css";
@import "styles/tenantUserForm.css";

@font-face {
    font-family: "Poppins Light";
    font-display: auto;
    src: local("PoppinsLight"),
    url("./assets/fonts/FontsFree-Net-Poppins-Light.ttf") format("truetype");
}

@font-face {
    font-family: "Poppins SemiBold";
    font-display: auto;
    src: local("PoppinsSemiBold"),
    url("./assets/fonts/Poppins-SemiBold.ttf") format("truetype");
}

@font-face {
    font-family: "Poppins Regular";
    font-display: auto;
    src: local("PoppinsMedium"),
    url("./assets/fonts/Poppins-Regular.ttf") format("truetype");
}

@font-face {
    font-family: "Poppins Medium";
    font-display: auto;
    src: local("PoppinsMedium"),
    url("./assets/fonts/Poppins-Medium.ttf") format("truetype");
}

/********************************************* old part of stylesheets ***************************************************************/


/*DOM elements*/
* {
    font-family: "Poppins Light" !important;
}

a {
    text-decoration: none;
    color: #307ade;
}

tr {
    border: 1px solid lightgray;
    font-weight: 500;
    height: 40px !important;
}

th {
    font-size: 0.8em;
    font-weight: bold;
}

.textBold {
    font-family: "Poppins SemiBold" !important;
    font-weight: bold !important;
}

.cardTitleProfile {
    font-weight: 300;
    font-size: 14px;
    display: flex !important;
    justify-content: space-between !important;
    margin-bottom: 16px !important;
    margin-top: 0 !important;
}

.cardTitle {
    font-weight: 300;
    font-size: 20px;
    width: 100% !important;
    display: flex !important;
    justify-content: space-between !important;
    margin-bottom: 16px !important;
    margin-top: 0 !important;
    font-family: "Poppins Regular", sans-serif;
}

.cardTitle > span {
    font-weight: 300;
    font-size: 20px;
}

.cardTitleOpen {
    margin-bottom: 13.4px;
}

.cardTitleClose {
    margin: 0;
    margin-bottom: 0 !important;
}

.noRead {
    font-family: "Poppins SemiBold" !important;
    width: 100%;
    display: flex;
    flex-direction: column !important;
}

.noRead > .InvoiceNumberWrap {
    font-family: "Poppins SemiBold" !important;
}

.InvoiceNumber {
    display: flex;
    flex-direction: row;
    font-weight: inherit !important;
    align-items: center;
    gap: 5px;
}

.noRead:has(.TransmissionItem) {
    flex-direction: row !important;
}

.noRead > span {
    font-family: "Poppins SemiBold" !important;
}

.FilterIconActiveIcon {
    font-size: 28px;
    fill: rgba(48, 122, 222, 0.3) !important;
}

.selectedOption {
    color: #307ade;
    font-family: "Poppins Medium" !important;
    font-size: 14px !important;
}

.unSelectedOption {
    color: #000;
    font-family: "Poppins Light" !important;
    font-size: 14px !important;
}


.status {
    min-width: 40px !important;
    border-radius: 20px !important;
    height: 20px !important;
    background: white !important;
    color: #307ade !important;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: text !important;
    border: 0.5px solid rgba(48, 122, 222, 0.1) !important;
    font-size: 9px !important;
    padding: 1px 8px !important;
    cursor: default !important;
}

.statusDocError {
    border-radius: 6px !important;
    border: 0.5px solid rgba(218, 79, 163, 0.3) !important;
    background-color: rgba(218, 79, 163, 0.1) !important;
}

.statusDocError > .MuiChip-label {
    color: #da4fa3 !important;
    font-family: "Poppins Medium" !important;
    font-size: 12px;
}

.statusDocSucces {
    background-color: white !important;
}

.statusDocSucces > .MuiChip-label {
    color: #000000 !important;
    font-family: "Poppins Medium" !important;
    font-size: 12px;
}


.avatarLogin {
    color: #307ade !important;
    font-size: 48px !important;
    width: 100px !important;
    height: 100px !important;
    font-family: "Poppins Light" !important;
    background-color: #f5fafe !important;
    border-color: rgba(48, 123, 222, 0.1);
    border-width: 1px;
    border-style: solid;
}

.userDetailTop {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 18px;
    color: #000000;
    margin-top: 20px !important;
}

.MenuLabel {
    font-weight: bolder !important;
}

.ReactFlagsSelect-module_selectBtn__19wW7 {
    color: #307ade !important;
    border: none !important;
    background-color: #f5fafe !important;
    height: 45px !important;
    display: flex !important;
    justify-content: center !important;
}

.ReactFlagsSelect-module_selectBtn__19wW7:after {
    color: #307ade !important;
}


.react-pdf__Page__canvas {
    margin: 0 auto;
    width: auto !important;
    height: 90vh !important;
}

input[type="checkbox"] {
    accent-color: #307ade;
}

.App {
    text-align: center;
}

.App-logo {
    height: 40vmin;
    pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
    .App-logo {
        animation: App-logo-spin infinite 20s linear;
    }
}

.MuiToolbar-root > div:nth-child(2) {
    flex: none;
}

@keyframes App-logo-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

/*****************************/
/********************************/
/******************************************* new part of stylesheet ********************************************************************/
.DetailContainer {
    display: flex !important;
    flex-direction: row !important;
    padding: 0 !important;
    flex-wrap: nowrap !important;
    gap: 16px !important;
}

.DetailLeftRow {
    background-color: transparent;
    border-radius: 0.428rem;
    flex: 1;
    display: flex;
    flex-direction: column !important;
    gap: 16px !important;
    height: fit-content;
}

.DetailCardBox {
    background-color: white;
    border-radius: 0.428rem;
    box-shadow: 1px 1px 10px rgba(216, 216, 216, 0.5);
    padding: 16px 16px;
    gap: 16px !important;
}

.FullParent {
    width: 100% !important;
    height: 100% !important;
    display: flex;
    flex-direction: column;

    padding: 0 !important;
    margin: 0 !important;
}

.FullParent > div {
    width: 100%;
    justify-content: flex-start;
}

.navBar {
    background-color: #fff;
    height: 80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px 0;
    width: 100% !important;
}

.navBarDetail {
    background-color: #fff;
    height: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 13px 0 10px 0;
}

.navBarTitle {
    float: left;
    width: fit-content !important;
    max-height: 100%;
    text-transform: none !important;
}

.TabItemsFav {
    height: 32px !important;
    text-transform: none !important;
    font-family: "Poppins Light";
    background-color: white !important;
    align-content: flex-start !important;
    text-align: left !important;
    text-transform: none;
    font-size: 14px !important;
    line-height: 17.5px;
    padding: 0 16px !important;
    display: flex !important;
    align-items: center !important;
    background-color: #ffffff !important;
    text-transform: none !important;
    border-radius: 8px !important;
    color: #000 !important;
    font-family: "Poppins Light" !important;
    min-height: 10px !important;
    font-weight: 500 !important;
}

.TabItems {
    height: 32px !important;
    text-transform: none !important;
    font-family: "Poppins Light";
    border-radius: 8px;
    background-color: white;
    align-content: flex-start !important;
    text-align: left !important;
    text-transform: none;
    font-size: 14px !important;
    line-height: 17.5px;
    padding: 0 16px !important;
    display: flex !important;
    align-items: center !important;
    background-color: #ffffff !important;
    border-radius: 6px !important;
    text-transform: none !important;
    border-radius: 8px;
    color: #000 !important;
    font-family: "Poppins Light" !important;
    min-height: 10px !important;
    font-weight: 500 !important;
}

.summaryHeaderError {
    width: 100%;
    height: 6px;
    background-image: url("assets/images/tenantbg.jpg");
    background-position: 7% 14%;
    background-size: 107%;
    background-repeat: no-repeat;
}

.summaryHeader {
    width: 100%;
    height: 6px;
    border-radius: 6px 6px 0 0;
    background-image: url("assets/images/tenantbg.jpg");
    background-position: 7% 14%;
    background-size: 107%;
    background-repeat: no-repeat;
}

.summaryBox {
    background-color: #fff;
    height: 74px;
    border-radius: 8px;
    box-shadow: 1px 1px 10px rgba(216, 216, 216, 0.5);
    width: 100% !important;
    margin-bottom: 16px !important;
    display: flex;
    align-items: center;
}

.summaryLabel {
    font-weight: 300;
    color: #000000;
    font-size: 14px;
    padding: 0;
    margin: 25px 10px 25px 25px;
}

.summaryStatBox {
    border-radius: 4px;
    display: flex;
    align-items: center;
    margin-left: 40px;
}

.summaryStat {
    font-weight: 300;
    color: #000000;
    font-size: 14px;
    padding: 0;
    margin-left: 10px;
    height: 100%;
    display: flex;
    align-items: center;
}

.summaryCount {
    font-weight: 600;
    font-size: 14px;
    color: #000000;
    font-family: "Poppins SemiBold" !important;
    justify-content: center;
    align-items: center;
    display: flex;
    height: 100% !important;
}


.ClosePreviewPdf {
    height: 44px;
    border-radius: 6px !important;
    font-size: 16px !important;
    width: 100% !important;
    padding: 13px 15px;
    text-transform: none !important;
    box-shadow: none !important;
    font-family: "Poppins SemiBold" !important;
}

.loader {
    display: block !important;
    margin: auto;
    position: relative;
    top: 250px;
}

.loaderBtn {
    color: white !important;
    width: 5px;
}

.downloadBtn {
    background-color: #f5fafe !important;
    color: #307ade !important;
    font-size: 14px !important;
    font-weight: 300 !important;
    border: none !important;
    box-shadow: none !important;
    text-transform: none !important;
    height: 36px !important;
}


/*** FilterBox components ***/

.filterBox {
    -webkit-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    -o-transition: all 0.5s ease;
    transition: all 0.5s ease;
    width: 400px;
    background-color: #fff;
    border-radius: 6px;
    z-index: 100;
    box-shadow: 0 1px 10px -2px rgba(0, 0, 0, 0.38);
    display: flex;
    flex-direction: column;
    padding: 10px !important;
    top: 10px;
}

/*************End****************/

/*** SubMenuButton ***/

.btnIcon {
    width: 40px !important;
    height: 40px !important;
    border-radius: 6px !important;
    padding: 6.5px !important;
}

.primaryBtnIconActive {
    background-color: #f5fafe !important;
    border: 1px solid rgba(48, 122, 222, 0.1) !important;
}

.primaryBtnIconActiveBlue {
    background-color: rgba(48, 122, 222, 0.1) !important;
    border: 1px solid rgba(48, 122, 222, 0.1) !important;
}

.primaryBtnIconActiveGold {
    background: #e8c6114d !important;
    border: 0.5px solid rgba(232, 198, 17, 0.3) !important;
}

.primaryBtnIconActiveBlueCustom {
    background-color: rgba(48, 122, 222, 0.1) !important;
    border: 1px solid rgba(48, 122, 222, 0.1) !important;
}

.primaryBtnIconActiveBlue > .MuiButton-label > svg {
    fill: rgba(48, 122, 222, 0.3) !important;
}

.primaryBtnIconActiveGold > .MuiButton-label > svg {
    fill: #e8c6114d !important;
}

.primaryBtnIconActiveBlue > svg {
    background-color: #f5fafe !important;
    border: 1px solid rgba(48, 122, 222, 0.1) !important;
    fill: rgba(48, 122, 222, 0.3) !important;
}

.primaryBtnIconActiveBlueCustom > svg {
    background-color: transparent !important;
    fill: rgba(48, 122, 222, 0.3) !important;
}

.primaryBtnIconActive > svg {
    background-color: #f5fafe !important;
    border: 1px solid rgba(48, 122, 222, 0.1) !important;
    fill: rgba(48, 122, 222, 0.3) !important;
}

.primaryBtnIcon {
    background-color: white !important;
    border: 1px solid #307ade1a !important;
    padding: 0 10px;
}

.primaryBtnIconGold {
    background-color: white !important;
    border: 1px solid #e8c6114d !important;
    padding: 0 10px;
}

.primaryBtnIcon > .MuiButton-label > span {
    color: white !important;
}

.primaryBtnIcon > svg {
    color: #307ade !important;
}

.primaryBtnIconGold > svg {
    color: #e8c611 !important;
}

.primaryBtnIcon > span > svg {
    color: #307ade !important;
}

.primaryBtnIcon:hover {
    background: rgba(48, 122, 222, 0.1) !important;
    border: 1px solid rgba(48, 122, 222, 0.3) !important;
}

.primaryBtnIcon.active {
    background: rgba(48, 122, 222, 0.1) !important;
    border: 1px solid rgba(48, 122, 222, 0.3) !important;
}

.primaryBtnIcon:hover > svg {
    color: #307ade !important;
    fill: rgba(48, 122, 222, 0.3) !important;
}

.primaryBtnIcon.active > span > svg {
    color: #307ade !important;
    fill: rgba(48, 122, 222, 0.3) !important;
}

.primaryBtnIcon.active > svg {
    color: #307ade !important;
    fill: rgba(48, 122, 222, 0.3) !important;
}

.primaryBtnIcon:hover > span > svg {
    color: #307ade !important;
    fill: rgba(48, 122, 222, 0.3) !important;
}

.dangerBtnIcon {
    background-color: white !important;
    border: 1px solid rgba(218, 79, 163, 0.1) !important;
}

.dangerBtnIcon > svg {
    color: #cb5aa0 !important;
}

.dangerBtnIcon > span > svg {
    color: #cb5aa0 !important;
}

.dangerBtnIcon:hover {
    background-color: rgba(218, 79, 163, 0.1) !important;
}

.dangerBtnIcon:hover > svg {
    color: #cb5aa0 !important;
    fill: rgba(218, 79, 163, 0.3) !important;
    stroke: #cb5aa0 !important;
}


.textActive {
    color: #307ade !important;
}


.BtnPrimaryActive:hover {
    background-color: rgba(48, 95, 178, 1) !important;
}

/**** dialogNewApiContainer ****/

.dialogNewApiContainer {
    display: flex;
    flex-direction: column;
    min-height: 190px;
    min-width: 340px;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 25px;
}

.closeBtnDialogNewApiDangger {
    width: 100%;
    margin-top: 25px !important;
    font-family: "Poppins SemiBold" !important;
    background-color: #da4fa3 !important;
    color: white !important;
    text-transform: none !important;
}

.closeBtnDialogNewApiDangger:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
    #da4fa3 !important;
    color: white !important;
}

.closeBtnDialogNewApi:hover {
    background: linear-gradient(
            0deg,
            rgba(21, 68, 146, 0.5),
            rgba(21, 68, 146, 0.5)
    ),
    #307ade !important;
    color: white !important;
}

.closeBtnDialogNewApiOutLine {
    width: 100%;
    margin-top: 25px !important;
    background-color: white !important;
    color: #307ade !important;
    border: none !important;
    text-transform: none !important;
}

.closeBtnDialogNewApiOutLine > span {
    /* font-family: "Poppins SemiBold" !important; */
}

.closeBtnDialogNewApiOutLine:hover {
    background-color: #f5fafe !important;
    color: #307ade !important;
}

.marginTop25 {
    margin-top: 25px !important;
}

.dialogNewApiCardContentInput {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.dialogNewApiCardTitle {
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    font-family: "Poppins Medium" !important;
}

.txtDetailForm[disabled] {
    color: #307ade !important;
}

.inputDisabledApiForm {
    color: #307ade !important;
    text-align: start !important;
    margin: 0px !important;
    font-size: 14px !important;
    padding: 0px 12px !important;
    height: 100% !important;
}

.inputDisabledApiForm:disabled {
    color: #307ade !important;
    text-align: start;
    margin: 0px;
    font-size: 14px;
    font-family: "Poppins SemiBold";
    padding: 0px 12px;
    height: 100%;
}

.dialogNewApiCardHeader {
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
    width: 100%;
    font-family: "Poppins Medium" !important;
}

.dialogNewApiCardContent {
    font-size: 12px !important;
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.dialogNewApiCardContentInput {
    display: flex;
    flex-direction: row;

    align-items: center;
}

.txtDetailForm[disabled] {
    color: #307ade !important;
}

.inputDisabledApiForm {
    color: #307ade !important;
    text-align: start !important;
    margin: 0px !important;
    font-size: 14px !important;
    padding: 0px 12px !important;
    height: 100% !important;
}

.inputDisabledApiForm:disabled {
    color: #307ade !important;
    text-align: start;
    margin: 0px;
    font-size: 14px;
    font-family: "Poppins SemiBold";
    padding: 0px 12px;
    height: 100%;
}

button:has(.IconActiveBtn) {
    background-color: white !important;
    border: 1px solid rgba(48, 122, 222, 0.1) !important;
}

.IconActiveBtnSlim {
    color: #307ade !important;
    width: 20px !important;
    height: 20px !important;
}

.IconDangerBtnSlim {
    color: #cb5aa0 !important;
    stroke: #cb5aa0 !important;
    width: 20px !important;
    height: 20px !important;
}

.IconActiveBtnSlim2 {
    color: #307ade !important;
    width: 18px !important;
    height: 18px !important;
}

.IconActiveBtn {
    color: #307ade !important;
}

button:has(.IconActiveBtn):hover {
    background: rgba(48, 122, 222, 0.1) !important;
    border: 1px solid rgba(48, 122, 222, 0.3) !important;
}

button:has(.IconActiveBtn):hover > span > svg {
    color: #307ade !important;
    fill: rgba(48, 122, 222, 0.3) !important;
    stroke: #307ade !important;
}

.noBottom {
    margin-bottom: 0 !important;
}

.downloadBtn:hover {
    background-color: #307ade !important;
    color: #fff !important;
}


input[type="date"]::-webkit-calendar-picker-indicator {
    cursor: pointer;
    border-radius: 4px;
    margin-right: 2px;
    opacity: 0.6;
    filter: invert(0.8);
}

.checkBoxHeader {
    padding: 0px !important;
}

.paddingLeft25 {
    padding-left: 25 !important;
}

.pointer {
    cursor: pointer !important;
}

input[type="date"]::-webkit-calendar-picker-indicator:hover {
    opacity: 1;
}

.pastilleAvatar {
    z-index: 1;
}

.pastilleAvatar:hover {
    z-index: 12;
}

.DashboardStatBlock {
    display: flex;
    flex-direction: row;
    width: 100%;
    background-color: white;
    justify-content: flex-start;
    align-items: center;
    height: 56px;
}

.statTxt {
    margin-left: 15px;
    display: flex;
    flex-direction: column;
}

.neutralTab {
    display: flex;
    align-items: center !important;
    height: 100% !important;
    width: 100% !important;
}

.neutralTab > span {
    height: 100% !important;
    width: 100% !important;
    display: flex;
    align-items: center;
}

.neutralTab > span > span {
    width: 100% !important;
}


.roleSelectBloc {
    width: 600px !important;
}

.statAvancé {
    width: 1px;
}

.JustifyStart {
    justify-content: flex-start !important;
}

.ServiceChoiceBtn {
    height: 38px;
    padding: 4px;
    margin-right: 5px;
    font-size: 14px !important;
    background-color: rgba(48, 122, 222, 0.1) !important;
    color: #307ade !important;
    text-transform: lowercase;
    border-radius: 6px;
    padding: 16px !important;
}

.ServiceChoiceBtn:hover {
    background-color: #307ade !important;
    color: white !important;
    font-family: "Poppins SemiBold";
    font-size: 14px !important;
}

.titleMessageBoxError {
    font-size: 34px;
    font-family: "Poppins Light";
    font-weight: 275;
    width: 100%;
    margin-top: 30px;
}

.confirmBoxBtns {
    margin-top: 30px;
    display: flex;
    justify-content: center;
}

.BtnsConfirmBox {
    padding: 13px 20px !important;
    font-size: 16px !important;
    text-transform: none !important;
    font-weight: 600 !important;
    border-radius: 6px !important;
}

.containerError {
    width: 100%;
    height: 100%;
}

.imgLogoMessageReceiver {
    width: 200px;
    margin-left: 50px;
    margin-top: 50px;
}

.bodyMessageReceiver {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.illuMessage {
    width: 700px;
}

.textMessageBox {
    width: 80%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    text-align: center;
}

.validConfirmBtnError {
    background-color: #307ade !important;
    color: white !important;
    font-size: 14px !important;
    font-family: "Poppins SemiBold" !important;
    height: 44px !important;
    padding: 13px !important;
}


.ReactFlagsSelect-module_selectBtn__19wW7:after,
.ReactFlagsSelect-module_selectBtn__19wW7[aria-expanded="true"]:after {
    content: "" !important;
    display: none !important;
}

.containerEnvelopWrap {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    width: 100%;
    background-color: #fff;
    height: auto;
    box-shadow: 1px 1px 10px 0px rgba(216, 216, 216, 0.5);
    border-radius: 10px;
    margin: 20px;
    margin-top: 0px;
    margin-bottom: 0px;
    justify-content: flex-start;
}

.containerEnvelopWrap.open {
    height: 450px;
    transition: height 0.8s ease-in;
}


.statusDocWarning {
    background: #d5895e1a !important;
    border: 1px solid #d5895e4d !important;
    color: #d5895e !important;
}


.LabelDetails {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
}

.bodyACS_Container_items {
    display: flex;
    flex-direction: row;
    margin-top: 5px;
    display: flex;
    align-items: center;
    cursor: pointer;
    display: flex;
    height: 42px;
    align-items: center;
    justify-content: flex-start;
    position: relative;
}

.addIconSendField {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 135px;
    top: 25%;
    display: none;
}

.addIconSendField.showAddIcon {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 11px;
    top: 27%;
    display: block;
}

.addIconSend {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 15px;
    display: none;
}

.bodyACS_Container_items:hover {
    background-color: #f5fafe !important;
}

.bodyACS_Container_items:hover > .addIconSend {
    display: block;
}

.bodyACS_Container_items_title {
    font-weight: 300;
    font-size: 13px;
    color: #000;
}

.bodyACS_Container_items_subtitle {
    font-weight: 300;
    font-size: 10px;
    line-height: 14px;
    color: rgba(0, 0, 0, 0.7);
}

.bodyACS_Container_items:hover
> .LabelDetails
> .bodyACS_Container_items_title {
    color: #307ade !important;
}

.bodyACS_Container_items:hover
> .LabelDetails
> .bodyACS_Container_items_subtitle {
    color: #307ade !important;
}

.containerMessageSender {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.illuMsgSender {
    width: 700px;
    margin-top: 60px;
    margin-bottom: 40px;
}

.illuValidateUser {
    margin-right: 100px !important;
}

.downloadDowMsg {
    font-size: 25px;
    text-align: center;
    color: #000000;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
}

.confirmationSendingText {
    font-size: 25px;
    line-height: 46px;
    text-align: center;
    color: #000000;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
}

.secondPart {
    font-size: 19px;
    line-height: 18px;
    text-align: center;
    color: rgba(0, 0, 0, 0.7);
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
}


.MenuERE {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 20px;
    padding-right: 20px;
    font-family: "Poppins Light";
    font-size: 12px;
    line-height: 18px;
    color: #000000;
}

.reciverName {
    font-family: "Poppins Medium";
    font-size: 12px;
}

.reciverEmail {
    font-family: "Poppins Light";
    font-size: 10px;
}

.dropableFilesEre {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: rgba(21, 68, 146, 1);
    color: white;
    padding: 10px 20px;
    box-shadow: 1px 1px 10px rgba(216, 216, 216, 0.5);
    border-radius: 6px;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    height: auto;
    min-height: 80px;
    margin-top: 20px !important;
}

.enveloppeOption {
    font-family: "Poppins Light" !important;
    font-family: "Poppins Light" !important;
    margin: 0 10px;
    height: 36px;
    padding: 6px 15px;
    cursor: pointer;
    font-size: 14px;
}

.enveloppeOption.active {
    background-color: #f5fafe !important;
    color: #307ade !important;
    font-family: "Poppins SemiBold" !important;
    border-radius: 6px;
}

.envolepeOpen {
    min-height: 300px !important;
    width: 100%;
    padding: 25px;
}

.documentType {
    font-family: "Poppins Medium" !important;
    font-size: 10px;
}

.containerMessageSender {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.rightSideValidateUser {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.containerMessageSenderValidate {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: calc(100% - 80px);
}

.status > .MuiChip-label {
    font-size: 10px !important;
    padding: 0 !important;
}

.searchField {
    width: 100% !important;
    background: none;
    border: none;
    height: 100%;
    color: #00000a;
}

.searchField::placeholder {
    color: var(--color-black);
    opacity: 0.5;
}

.SearchIcon {
    margin: 8px;
    position: absolute;
    z-index: 10;
    left: 0px;
    cursor: pointer;
}

.FilterIconInput {
    margin: 8px;
    position: absolute;
    z-index: 10;
    right: 0px;
    cursor: pointer;
    font-size: 28px;
    color: #307ade !important;
}

.FilterIconInputIcon {
    cursor: pointer;
    font-size: 28px;
    color: black !important;
}

.searchField:focus,
.searchField:focus-visible {
    border: none !important;
    outline: 1px solid #307ade !important;
    border-radius: 6px !important;
}

.BtnPrimaryActive.Mui-disabled {
    display: none;
}

.fadeOut {
    background-color: rgba(255, 255, 255, 1);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;

    visibility: hidden;
    opacity: 0;
    transition: visibility 0s 0.5s, opacity 0.5s linear;
}

.fadeIn {
    visibility: visible;
    background-color: rgba(255, 255, 255, 1);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    height: 100%;
    right: 0;
    z-index: 100;
}

.SubTitle {
    font-size: 14px;
    font-family: "Poppins Medium" !important;
    margin-top: 30px !important;
    margin-bottom: 10px;
}

.SpecialSwitch.Mui-disabled
> .css-1er0im1-MuiSwitch-root
.MuiSwitch-switchBase.Mui-checked
+ .MuiSwitch-track {
    background-color: #1976d2 !important;
}

.active {
    background-color: #307ade !important;
    color: white !important;
}

button:has(.IconDeleBtn) {
    background-color: white !important;
    border: 1px solid rgba(218, 79, 163, 0.1) !important;
}

.IconDeleBtn {
    color: #cb5aa0 !important;
    stroke: #cb5aa0 !important;
    width: 20px;
    height: 20px;
}

button:has(.IconDeleBtn):hover {
    background-color: rgba(218, 79, 163, 0.1) !important;
    border: 1px solid rgba(218, 79, 163, 0.3) !important;
}

button:has(.IconDeleBtn):hover > svg {
    color: #cb5aa0 !important;
    fill: rgba(218, 79, 163, 0.3) !important;
    stroke: #cb5aa0 !important;
}

button:has(.IconDeleBtn):hover > span > svg {
    color: #cb5aa0 !important;
    fill: rgba(218, 79, 163, 0.3) !important;
    stroke: #cb5aa0 !important;
}

.closeBtnDialogNewApi {
    width: 100%;
    font-family: "Poppins SemiBold" !important;
    margin-top: 25px !important;
    background-color: #307ade !important;
    color: white !important;
    text-transform: none !important;
    border: none !important;
}

.closeBtnDialogNewApi > span {
    font-family: "Poppins SemiBold" !important;
}

.closeBtnDialogNewApiDangger {
    width: 100%;
    margin-top: 25px !important;
    font-family: "Poppins SemiBold" !important;
    background-color: #da4fa3 !important;
    color: white !important;
    text-transform: none !important;
}

.closeBtnDialogNewApi > .MuiButton-labelan {
    font-family: "Poppins SemiBold" !important;
}

.closeBtnDialogNewApiDangger > .MuiButton-label {
    font-family: "Poppins SemiBold" !important;
}

.invisibelInput {
    background: none !important;
    border: none !important;
    font-size: 20px !important;
    padding: 0 !important;
    margin: 0 !important;
    height: 16px !important;
}

.selectDetailForm > fieldset {
    border: 0.5px solid rgba(48, 122, 222, 0.3) !important;
}

.topCard > .MuiPopover-paper {
    top: auto !important;
    bottom: 82px !important;
}

.bottomCard > .MuiPopover-paper {
    top: auto !important;
    bottom: 82px !important;
}

.containerPopup {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 72px;
    max-width: 430px;
    min-width: 330px;
    padding: 10px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 2px 2px 10px rgba(216, 216, 216, 1);
    border-radius: 6px;
}

.popupIcon {
    padding: 8px;
    width: 60px;
    height: 60px;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.popupIcon > svg {
    height: 35px;
    width: 35px;
}

.popupIcon {
    margin-right: 10px;
}

.popupText {
    display: flex;
    flex-direction: column;
}

.popupTitle {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    font-family: "Poppins Medium" !important;
}

.popupTextBody {
    font-weight: 300;
    font-size: 11px;
    line-height: 15px;
    color: #000;
}

.popupCode {
    font-weight: 300;
    font-size: 10px;
    line-height: 15px;

    color: rgba(0, 0, 0, 0.7);
}

.PreviewPdf > .react-pdf__Document > .react-pdf__Page > canvas {
    height: 550px !important;
}

.thirdPartieCOntactNumber {
    width: 28px !important;
    height: 28px !important;
    background: #ffffff !important;
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
    border-radius: 6px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px !important;
    font-size: 14px;
}

.editBox > .width90 {
    height: 35px !important;
    max-height: 35px !important;
    width: 90px !important;
}

.__react_component_tooltip {
    max-width: 250px;
    white-space: normal;
}

.allBold > td {
    font-size: 10px !important;
    font-family: "Poppins SemiBold" !important;
}

.allBold > td > div {
    font-size: 10px !important;
    font-family: "Poppins SemiBold" !important;
}

.allBold > td > div > span {
    font-size: 10px !important;
    font-family: "Poppins SemiBold" !important;
}

.allBold > td > div > span > span {
    font-size: 10px !important;
    font-family: "Poppins SemiBold" !important;
}

.allBold > td > span {
    font-size: 10px !important;
    font-family: "Poppins SemiBold" !important;
}

.allBold > td > span > span {
    font-size: 10px !important;
    font-family: "Poppins SemiBold" !important;
}

.allBold > td > .boldDate {
    font-size: 10px !important;
}

.PhoneInput {
    height: 40px;
    background: #ffffff;
    border: 0.5px solid rgba(48, 122, 222, 0.3);
    border-radius: 6px;
    padding: 0 10px;
}

.PhoneInputInput {
    background: none;
    border: none;
    height: 100%;
    color: #307ade;
}

.PhoneInputInput::placeholder {
    color: #307ade;
    opacity: 1; /* Firefox */
}

.TransmissionItem {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 35px;
    justify-content: space-between;
    margin-right: 16px !important;
}

.MediaTypeDetail {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 6px !important;
}

.MediaType {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 80px;
    margin-left: 6px !important;
}

.TransmissionItemChorus {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 35px;
    justify-content: space-between;
    margin-right: 16px !important;
}

div:has(.TransmissionItem) {
    justify-content: flex-start;
}

div:has(.TransmissionItemChorus) {
    justify-content: flex-start;
}

.PhoneInputCountryIcon--border {
    box-shadow: none !important;
    border-radius: 3px !important;
}

.PhoneInputCountryIcon {
    border-radius: 3px !important;
}

.PhoneInputCountryIconImg {
    border-radius: 3px !important;
}

.PhoneInputCountrySelectArrow {
    font-size: 20px !important;
    color: #307ade !important;
    font-family: "Poppins SemiBold" !important;
}

.logOutBtn {
    font-size: 12px !important;
}

.toggleBtn {
    border: none !important;
    text-transform: capitalize !important;
}

.toggleBtn.Mui-selected {
    background: #f5fafe !important;
    background-color: #f5fafe !important;
    border: 0.5px solid rgba(48, 122, 222, 0.1) !important;
    border-radius: 3px !important;
    color: #307ade !important;
    font-size: 12px !important;
    text-transform: capitalize !important;
}

.validationUserNavBar {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    padding: 30px !important;
}

.validationUserNavBar > img {
    width: 200px;
    height: auto;
}

.TableNew {
    display: none;
}

.TableNew > .MuiIconButton-label > input {
    display: none;
}


.downloadDocTitile {
    font-size: 25px;
    text-align: center;
    color: #000000;
    flex: none;
    order: 0;
    flex-grow: 0;
}

.downloadDowMsgSub {
    font-size: 22px;
    text-align: center;
    color: #000000;
    flex: none;
    order: 0;
    flex-grow: 0;
}

.dwnDovX {
    min-height: 48px !important;
    min-width: 160px !important;
}

.dwnDovX > .MuiButton-label {
    font-size: 16px;
}

.downloadDocTitile > span {
    font-family: "Poppins SemiBold" !important;
}

.validateUserTitle {
    font-size: 30px;
    font-family: "Poppins SemiBold" !important;
    text-align: center;
    color: #000000;
    flex: none;
    order: 0;
    flex-grow: 0;
}

.BtnPrimaryActive {
    font-size: 14px !important;
    text-transform: none !important;
    background-color: #307ade !important;
    color: white !important;
    font-weight: 300 !important;
    border: none !important;
    box-shadow: none !important;
    font-family: "Poppins SemiBold" !important;
    height: 36.5px !important;
}

.BtnPrimaryActive > .MuiButton-label {
    font-family: "Poppins SemiBold" !important;
}

.ClosePreviewPdf > .MuiButton-label {
    font-family: "Poppins SemiBold" !important;
}

.statNumber {
    font-family: "Poppins Regular" !important;
}

.fullRow {
    flex-direction: row !important;
}

.CustomTabGroupe {
    display: flex;
    align-items: center;
    margin-left: 25px;
}

.CustomTabGroupe > div > .MuiTabs-flexContainer > button {
    min-width: 60px;
}

.CustomTabGroupe > div > .MuiTabs-flexContainer > .TabItems.Mui-selected {
    min-width: 60px;
}

.CustomTabGroupe > div.MuiTabs-scroller > span.MuiTabs-indicator {
    display: block;
    min-width: 60px;
    height: 3px;
    border-radius: 2px;
    background-color: #307ade !important;
}

.CustomTabGroupe > div.MuiTabs-scroller {
    display: flex;
    align-items: center;
    height: 30px !important;
}

.CustomTabItems > .MuiTab-wrapper {
    font-size: 14px;
    text-transform: capitalize;
}

.CustomTabItems.Mui-selected > .MuiTab-wrapper {
    font-size: 14px;
    text-transform: capitalize;
    font-family: "Poppins Medium" !important;
}

.closeBtnDialogNewApi.Mui-disabled {
    opacity: 0.8 !important;
}

.primaryBtnIconColorTable {
    color: #3079de;
    width: 20px;
    height: 20px;
}

.primaryBtnIconColor {
    color: #3079de;
}

.hoverFilter {
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.35);
    width: 100%;
    height: 100%;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    display: none;
}

.PreviewTable:hover > .hoverFilter {
    display: flex !important;
}

.preview-card.PreviewTable {
    overflow: hidden;
}

.preview-card.PreviewTable > .react-pdf__Document > .react-pdf__Page > .react-pdf__Page__canvas {
    box-sizing: border-box;
    display: block;
    margin: 0 auto;
    width: 100% !important;
    height: auto !important;
}

.pdf-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
}

.secondariBtn {
    border: 0.5px solid rgba(48, 122, 222, 0.3) !important;
    border-radius: 6px;
    display: flex;
    padding: 5px 8px;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.secondariBtn:hover {
    background-color: rgba(48, 122, 222, 0.1) !important;
}

.secondariBtn > span {
    color: #307ade;
    text-align: center;
    font-size: 10px;
    line-height: 18px;
    text-transform: none;
}

.rightOfParent {
    position: absolute !important;
    right: 0px;
}

.documentToAddStatus > span {
    font-size: 12px;
}

.documentToAddStatus {
    height: auto !important;
}

.documentToAddStatus > .MuiChip-label {
    padding: 0 8px !important;
}

.DocumentEreTable > tbody > tr:hover {
    background-color: #f5fafe;
}

.ReadyToSend {
    border-radius: 6px;
    border: 1px solid rgba(48, 122, 222, 0.1);
    background: linear-gradient(
            0deg,
            rgba(48, 122, 222, 0.1) 0%,
            rgba(48, 122, 222, 0.1) 100%
    ),
    #fff;

    display: flex;
    width: 75px;
    padding: 5px 3px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    color: #307ade;
    font-size: 10px;
    line-height: 18px;
    position: absolute;
    left: 53px;
}

.ImportBtn {
    text-transform: lowercase !important;
    font-size: 14px;
    color: #3079de;
}

.ImportBtn > span {
    text-transform: lowercase !important;
    font-size: 14px;
    color: #3079de;
}

div:has(.fullModal) {
    width: 600px !important;
}

/* ************************* new code base ***********************/
.NdInputSlotLeft {
    min-width: 0px !important;
    height: 100%;
}

.NdInputSlotRight {
    min-width: 0px !important;
    height: 100%;
}

.editIconRef {
    display: none;
}

.enterRefEmpty {
    cursor: pointer;
}

.enterRefEmpty:hover > .editIconRef {
    display: block !important;
}

.react-pdf__Page__textContent {
    display: none !important;
}


/* *********************************************************************************************** */
.Etiquette {
    padding: 1px 6px !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 2px !important;
    padding: 0 6px !important;
    height: 20px;
    border-radius: 4px !important;
    font-size: 10px !important;
    display: flex !important;
    width: max-content !important;
}

.btnPrimary {
    background: #307ade;
}

.btnPrimary > span {
    color: #fff !important;
    font-weight: 700;
}

.btnPrimary:hover {
    background: linear-gradient(
            0deg,
            rgba(21, 68, 146, 0.5) 0%,
            rgba(21, 68, 146, 0.5) 100%
    ),
    #307ade !important;
}

.Primary {
    border: 0.5px solid var(--blue-30, rgba(48, 122, 222, 0.3)) !important;
    background: linear-gradient(
            0deg,
            rgba(48, 122, 222, 0.1) 0%,
            rgba(48, 122, 222, 0.1) 100%
    ),
    #fff;
    color: #307ade !important;
}

.Primary > span {
    color: #307ade !important;
}

.Succes {
    border: 0.5px solid rgba(39, 174, 96, 0.3);
    background: rgba(39, 174, 96, 0.1);
    color: #27ae60;
}

.Tertiary {
    border: none !important;
    background: #fff !important;
    color: #000000b2 !important;
}

.Tertiary:hover {
    border: 0.5px solid rgba(0, 0, 0, 0.1) !important;
    background: #f9f9f9 !important;
    color: #000000b2 !important;
}

.Secondary {
    border: 0.5px solid rgba(48, 122, 222, 0.3) !important;
    background: #fff !important;
    color: #307ade !important;
}

.SecondaryDanger {
    border: 0.5px solid rgba(218, 79, 163, 0.3) !important;
    background: #fff !important;
    color: #da4fa3 !important;
}

.btn.SecondaryDanger:hover {
    border: 0.5px solid rgba(218, 79, 163, 0.5) !important;
    background: rgba(218, 79, 163, 0.1) !important;
    color: #da4fa3 !important;
}

.btn.Secondary:hover {
    border: 0.5px solid rgba(48, 122, 222, 0.5) !important;
    background: #307ade1a !important;
    color: #307ade !important;
}

.Warning {
    border: 0.5px solid rgba(213, 137, 94, 0.3);
    background: rgba(213, 137, 94, 0.1);
    color: #d5895e;
}

.Variant {
    border: 0.5px solid rgba(151, 71, 255, 0.3);
    background: rgba(151, 71, 255, 0.1);
    color: #9747ff;
}

.BtnSlm {
    height: 26px !important;
    font-size: 10px !important;
}

.inputDetailForm:focus-visible {
    outline: none !important;
}

.custom-checkbox-label {
    display: flex !important;
    align-items: center !important;
}

.fullBtn {
    width: 100% !important;
}

tr > td {
    display: table-cell !important;
    vertical-align: middle !important;
}

.BigPdfBox > .react-pdf__Page__canvas {
    height: 693px !important;
}

.limiteText {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    padding-right: 20px !important;
    display: block !important;
}

.fantomField {
    width: 100% !important;
    height: 100% !important;
    background-color: transparent;
    color: #307ade;
    text-align: left;
    font: 300 12px/18px "Poppins", sans-serif;
    border: none;
}

.fantomField:focus-visible {
    outline: none;
}

.ModalInputPhone {
    width: 100% !important;
    background-color: white;
}

.ColumnViewNoShadow {
    -webkit-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    -o-transition: all 0.5s ease;
    transition: all 0.5s ease;
    width: 260px;
    background-color: #fff;
    border-radius: 6px;
    z-index: 100;
    display: flex;
    flex-direction: column;
}

.PhoneInputCountrySelectArrow {
    display: none !important;
}

.showOnHover > div:only-child {
    width: 100%;
    justify-content: flex-end;
    padding-right: 18px;
}

.FilterBoxLayout {
    display: flex;
    padding: 8px;
    height: 36px;
    align-items: center;
    cursor: pointer;
}

.FilterBoxLayoutDisable {
    border-radius: 6px;
    border: 0.5px solid var(--black-30, rgba(0, 0, 0, 0.3));
    background: var(--White, #fff);
}

.FilterBoxLayoutEnable {
    border-radius: 6px;
    border: 0.5px solid var(--blue-30, rgba(48, 122, 222, 0.3));
    background: var(--blue-10, rgba(48, 122, 222, 0.1));
}

.FilterBoxLayoutDisable > svg {
    color: black !important;
}

.FilterBoxLayoutEnable > svg {
    color: #307ade !important;
}

.FilterBoxLayoutTextActive {
    color: var(--Blue, #307ade);
    /* Poppins Light 10 - 18 */
    margin-left: 5px;
    font-family: Poppins;
    font-size: 10px;
    font-style: normal;
    font-weight: 300;
    line-height: 18px; /* 180% */
}

.FilterBoxLayoutText {
    color: var(--black-70, rgba(0, 0, 0, 0.7));
    margin-left: 5px;
    /* Poppins Light 10 - 18 */
    font-family: Poppins;
    font-size: 10px;
    font-style: normal;
    font-weight: 300;
    line-height: 18px; /* 180% */
}

.NeutrePadding {
    padding: 0 !important;
}

.blockWrapper > div:nth-child(2) {
    width: 101% !important;
    height: calc(100% - 60px);
}

.blockWrapperSimple > div:nth-child(2) {
    width: 101% !important;
    height: 100% !important;
}

.searchField:focus-visible {
    outline: none !important;
}

.TabsGroup > .MuiTabs-scroller > .MuiTabs-flexContainer {
    overflow-x: hidden;
    max-width: 100% !important;
}

.TabItemsFavSelectedLabel {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-family: "Poppins SemiBold" !important;
    gap: 4px;
}

.TabItemsFavSelectedLabel > span {
    position: relative;
    top: 1px;
    font-family: "Poppins SemiBold" !important;
}

.MoreMenu {
    height: 30px;
    display: flex;
    padding: 5px;
    align-items: center;
    border-radius: 8px;
}

.MoreMenu:focus {
    background-color: #f9f9f9;
    border-radius: 4px;
    border: 0.5px solid var(--black-10, rgba(0, 0, 0, 0.1));
}

.MoreMenu:hover {
    background-color: #f9f9f9;
    border-radius: 4px;
    border: 0.5px solid var(--black-10, rgba(0, 0, 0, 0.1));
}

.height21 {
    height: 26px !important;
    font-size: 10px !important;
    border-radius: 4px !important;
}

.UserAccount {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
}

.userInfoDomainWrapper {
    border-radius: 4px;
    border: 0.5px solid var(--White, #fff);
    padding: 0 2px 0 2px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.userInfoDomain {
    color: var(--White, #fff);
    text-align: center;
    /* Poppins Light 9 - 14 */
    font-family: Poppins;
    font-size: 9px;
    font-style: normal;
    font-weight: 300;
}

.userInfoName {
    color: var(--White, #fff);
    font-family: "Poppins Medium" !important;
    font-size: 12px;
    font-weight: bold;
    line-height: 18px; /* 150% */
    width: 100%;
    display: flex;
    justify-content: flex-start;
}

.legacyDialogCss .MuiDialog-paperWidthSm {
    max-width: 100vw !important;
}

.MuiDialog-paperWidthSm {
    max-width: 100vw;
}


.detailTraitementLine {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    margin-bottom: 15px;
}

.flexContainerTable > div:first-child {
    overflow-x: auto !important;
}

.flexContainerTable {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex: 1;
}

.table-row {
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    display: flex !important;
}

.SG-datepicker__input-container input {
    max-width: 100px;
    border: none !important;
}

.SG-datepicker {
    margin: 0 !important;
}

.SG-datepicker__input-container > .calendar-icon {
    display: none !important;
}

.SG-datepicker__body > * > tr {
    border: none !important;
}

.SG-datepicker__calendar-container {
    height: 25em;
}

.SG-datepicker__day {
    border-radius: 10px !important;
    height: 1em !important;
}

.SG-datepicker__day:hover {
    background-color: #307ade !important;
    color: white;
}

.SG-datepicker__calendar-container {
    height: 30em !important;
}

.MuiTabs-indicator {
    display: none;
}

.itemLabel {
    /* padding: 6px 15px; */
    color: #000000;
    font-family: "Poppins Medium";
    background-color: #ffffff;
    font-weight: 300;
}

.toolBarTable > div:first-child > div[class^="MTableToolbar-highlight"] {
    background-color: white !important;
}

.toolBarTable > div:first-child > div:first-child {
    background-color: white !important;
}


.paddingLeft25 > div:first-child {
    padding-right: 10px !important;
}

.configWrap {
    display: flex !important;
    flex-direction: row;
    justify-content: center !important;
    align-items: center;
    width: 100%;
}

.configDescriptions {
    display: flex !important;
    flex: 1;
    flex-direction: column;
}

.configShortDescription {
    display: flex !important;
    font-size: 12px;
}

.configDescription {
    display: flex !important;
    font-size: 9px;
}

.noMargin {
    margin: 0 !important;
}

.navBarDetail_bottom {
    gap: 8px !important;
}

.smallSize {
    font-size: 10px !important;
}

.fantomField.etiquetteFeild {
    border: 1px solid rgba(48, 122, 222, 0.1) !important;
    font-size: 12px !important;
    padding: auto;
    width: 100px !important;
    max-width: 100% !important;
    min-width: 10px !important;
    border-radius: 6px;
    margin-top: 3px !important;
    height: 32px !important;
}

.fantomField.etiquetteEmpty {
    border: none !important;
    font-size: 12px !important;
    padding: auto;
    flex: 1 !important;
    max-width: 100% !important;
    min-width: 10px !important;
    border-radius: 6px;
    margin-top: 3px !important;
    height: 32px !important;
}

.flexColumn {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}

.flexColLight {
    display: flex;
    flex-direction: column;
}

.colStyle {
    height: 61px;
    color: #307ade;
    background-color: rgba(249, 249, 249, 0.5);
    border-radius: 6px 6px 0 0;
    border-bottom: 0.5px solid rgba(48, 122, 222, 0.3);
}

.type-de-doc,
.type-de-doc * {
    box-sizing: border-box;
}

.type-de-doc {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    width: auto;
    min-width: 68px;
    max-width: 100%;
    position: relative;
}

.type-tiquette {
    border-radius: 2px;
    display: flex;
    flex-direction: row;
    gap: 2px;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    position: relative;
    background-color: transparent;
}

.item {
    color: inherit;
    background-clip: text;
    -webkit-background-clip: text;
    text-align: center;
    font-family: "Poppins-Light", sans-serif;
    font-size: 9px;
    line-height: 12px;
    font-weight: 300;
    position: relative;
}

.etiquette {
    background: var(--white, #ffffff);
    border-radius: 3px;
    border-style: solid;
    border-color: var(--black-10, rgba(0, 0, 0, 0.1));
    border-width: 0.5px;
    padding: 1px 3px 1px 3px;
    display: flex;
    flex-direction: row;
    gap: 2px;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    position: relative;
}

.InvoiceNumberWrap {
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: flex-start;
}

.etiquetteDocumentAttache > svg {
    font-size: 15px;
}

.etiquetteDocumentAttache {
    font-size: 9px;
    border: 0.5px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding: 1px 6px 1px 6px;
    display: flex;
    flex-direction: row;
    gap: .5em;
    line-height: 18px;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    position: relative;
    cursor: pointer;
}

.jobMessageWrapSection {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.marginLeft8 {
    margin-left: 8px;
}

.separator {
    display: flex;
    align-items: center;
    height: 50%;
    align-items: center;
    justify-content: center;
}

.destinataire-contact,
.destinataire-contact * {
    box-sizing: border-box;
}

.destinataire-contact {
    display: flex;
    flex-direction: row;
    gap: 0px;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    width: 220px;
    position: relative;
}

.composant-position {
    display: flex;
    flex-direction: column;
    gap: 0px;
    align-items: flex-start;
    justify-content: center;
    flex-shrink: 0;
    width: 220px;
    position: relative;
}

.type-titres {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    position: relative;
}

.bottomline {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    position: relative;
}

.informations2 {
    text-align: left;
    font-size: var(--poppins-light-9-14-font-size, 9px);
    line-height: var(--poppins-light-9-14-line-height, 14px);
    font-weight: var(--poppins-light-9-14-font-weight, 300);
    position: relative;
}

.actif {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    position: relative;
}

.rectangle-223 {
    background: var(
            --black-70,
            linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
            linear-gradient(to left, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7))
    );
    border-radius: 3px;
    flex-shrink: 0;
    width: 3px;
    height: 3px;
    position: relative;
}

.type-element {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    min-height: 14px;
    position: relative;
}

.plateforme {
    border-radius: 6px;
    display: flex;
    flex-direction: row;
    gap: 0px;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    height: 14px;
    position: relative;
}

.chorus {
    border-radius: 6px;
    display: flex;
    flex-direction: row;
    gap: 0px;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    position: relative;
}

.type-element2 {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    width: 39px;
    min-height: 14px;
    position: relative;
}

.icone {
    display: flex;
    flex-direction: row;
    gap: 0px;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    position: relative;
}

.icones {
    padding: 1px;
    display: flex;
    flex-direction: column;
    gap: 0px;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    min-width: 12px;
    min-height: 12px;
    position: relative;
}

.group {
    flex-shrink: 0;
    width: 10px;
    height: 8.99px;
    position: relative;
    overflow: visible;
}

.CANCELED > .texte > .envoyer > span,
.CANCELED > .icones {
    color: #da4fa3 !important;
}

.All > .texte > .envoyer > span,
.All > .icones {
    color: #726e6e !important;
}

.ERROR > .texte > .envoyer > span,
.ERROR > .icones {
    color: #da4fa3 !important;
}

.COMPLETED > .texte > .envoyer > span,
.COMPLETED > .icones {
    color: #307ade !important;
}

.PROCESSING > .texte > .envoyer > span,
.PROCESSING > .icones {
    color: #307ade !important;
}

.recherche3 {
    width: 150px; /* Taille par défaut */
    transition: width 0.3s ease; /* Animation fluide */
}

.recherche3-focused {
    width: 250px; /* Taille quand en focus */
}

.commentWrap {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
    max-height: 250px;
    overflow-y: auto;
    scroll-behavior: smooth;
}

.NoBottomPadding {
    padding-bottom: 0 !important;
}

.NoTopPadding {
    padding-top: 0 !important;
}
